import { render } from "./a-task-timeblocks.vue?vue&type=template&id=1b2526e6&scoped=true"
import script from "./a-task-timeblocks.vue?vue&type=script&lang=js"
export * from "./a-task-timeblocks.vue?vue&type=script&lang=js"

import "./a-task-timeblocks.vue?vue&type=style&index=0&id=1b2526e6&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2526e6"]])

export default __exports__